// extracted by mini-css-extract-plugin
module.exports = {"item":"History_item__Dxa8c","container":"History_container__2vFnt","itemsheader":"History_itemsheader__cwD3O","showmore":"History_showmore__DiG5p"};